let model = {};
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  name: undefined, // required - Tên của popup
  width: undefined, // optional - Chiều rộng của popup
  type: null, // optional, enum(probe, bras, summary) - Tên phân hệ (mặc định bằng null nghĩa là probe)
};
model.tableRules = {
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 20,
  offset: 0,
  sort: "name",
  defaultSort: ["name", "ascending"],
  fields: "id,name,width,type",
  filters: "",
  dataSearch: {
    value: {
      name: "",
      type: "",
    },
    operator: {
      name: ":regex_i:",
      type: "",
    },
  },
};
model.listSuggestions = [
  { value: 480, unit: "px" },
  { value: 1024, unit: "px" },
  { value: 1265, unit: "px" },
  { value: 50, unit: "%" },
  { value: 80, unit: "%" },
];

export default model;
